import MobileDetect from 'mobile-detect';
import { createInjection } from 'src/lib/createInjection';

export interface MobileDetector {
  isMobile: () => boolean;
  isIOS: () => boolean;
  isAndroid: () => boolean;
}

const getMobileDetector = (userAgent: string): MobileDetector => {
  const md = new MobileDetect(userAgent);
  return {
    isMobile: () => !!md.mobile(),
    isIOS: () => md.is('iOS'),
    isAndroid: () => md.is('AndroidOS'),
  };
};

type EnvContext = {
  isProduction: boolean;
  isStaging: boolean;
  isDevelopment: boolean;
  mobileDetector: MobileDetector;
  isDebugShowGeoConnections: boolean;
  isDebugShowKpAllLayer: boolean;
  isDebugShowNoKpMovies: boolean;
};

const { provide, inject } = createInjection<EnvContext>('useEnv');

export function provideEnv(): void {
  const envEl = document.querySelector<HTMLMetaElement>('meta[name=environment]');
  const env = envEl?.content ?? '';
  const isProduction = env === 'production';
  const isStaging = env === 'staging' || env === 'stg';
  const params = new URLSearchParams(window.location.search);

  provide({
    isProduction,
    isStaging,
    isDevelopment: !isProduction && !isStaging,
    mobileDetector: getMobileDetector(window.navigator.userAgent),
    isDebugShowGeoConnections: params.has('debug_show_geo_connections'),
    isDebugShowKpAllLayer: params.has('debug_show_kp_all_layer'),
    isDebugShowNoKpMovies: params.has('debug_show_no_kp_movies'),
  });
}

export function useEnv(): EnvContext {
  return inject();
}
